<template>
  <m-card v-bind="$attrs" v-on="$listeners" style="padding: 0 !important">
    <v-card flat height="300" text class="pa-0">
      <v-chart auto-resize :options="options" theme="light" />
    </v-card>
    <template v-slot:footer v-slot="loading">
      <m-elapsed :loading="loading"></m-elapsed>
    </template>
  </m-card>
</template>

<style>
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/pie'
// import "echarts/lib/component/title";
// import "echarts/lib/component/tooltip";
import 'echarts/lib/component/legend'
// import echartsTheme from "ant-design-vue-echart-theme";

// ECharts.registerTheme("light", echartsTheme);

export default {
  inheritAttrs: false,
  components: {
    'v-chart': ECharts,
  },
  props: {
    opData: {
      default: () => [],
    },
    opConfig: {
      type: Object,
      default: () => {
        return { top: '0%', left: '0%', center: ['50%', '50%', '50%'], color: ['#66BB6A', '#388E3C'] }
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    options() {
      return {
        tooltip: {
          trigger: 'item',
          // formatter: "{a} <br/>{b} : {c} ({d}%)",
          formatter: '{b} : {c}',
          textStyle: {
            fontSize: 12,
            // color: this.$vuetify.theme.primary,
          },
        },
        legend: {
          data: this.opData.map((item) => {
            return item.name
          }),
          orient: 'vertical',
          left: this.opConfig.left,
          top: this.opConfig.top,
          // bottom: 20,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        series: {
          type: 'pie',
          color: this.opConfig.color,
          center: this.opConfig.center,
          label: {
            normal: {
              show: true,
              position: 'inner',
              // formatter: "{b} : {c} ({d}%)"
              formatter: '{d}%',
            },
            emphasis: {
              show: true,
            },
          },
          data: this.opData,
        },
      }
    },
  },
  mounted() {},
  methods: {},
}
</script>
